import React from 'react';

/**
 * LoadingProgress - A reusable loading component with animated progress bar
 * 
 * @param {number} progress - Progress percentage (0-100)
 * @param {string} logoSrc - Path to logo image (default: '/images/logo_blue.png')
 * @param {number} logoHeight - Height of logo in pixels (default: 56)
 * @param {string} className - Additional CSS classes for the container
 */
class LoadingProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
    };
    this.progressInterval = null;
  }

  componentDidMount() {
    this.startProgress();
  }

  componentWillUnmount() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  }

  startProgress() {
    this.setState({ progress: 0 });

    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }

    // Increase progress gradually up to 100% over ~30s
    this.progressInterval = setInterval(() => {
      this.setState((prev) => {
        if (prev.progress >= 100) {
          clearInterval(this.progressInterval);
          return prev;
        }
        return { progress: prev.progress + 1 };
      });
    }, 300); // ~100 steps * 300ms = 30000ms ≈ 30s
  }

  render() {
    const {
      logoSrc = '/images/logo_blue.png',
      logoHeight = 56,
      className = '',
    } = this.props;

    const progress = this.state.progress;

    return (
      <div className={`kpi-loading min-vh-100 d-flex flex-column align-items-center justify-content-center ${className}`}>
        <img
          className="kpi-loading-logo"
          src={logoSrc}
          alt="Logo"
          height={logoHeight}
        />
        <div
          className="kpi-progress"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={progress}
        >
          <div
            className="kpi-progress-fill"
            style={{
              width: `${progress}%`,
              transition: 'width 0.3s ease-out',
            }}
          />
        </div>
        <div className="kpi-progress-text">{progress}%</div>
      </div>
    );
  }
}

export default LoadingProgress;
